import { AmplitudeEvent } from "./AmplitudeEvent";
import MeetingState, { isValid as isMeetingStateValid } from "@/constants/MeetingState";

export class MeetingViewedEvent extends AmplitudeEvent {
	stateMap = {
		[ MeetingState.NONE ]: "not started",
		[ MeetingState.CREATED ]: "not started",
		[ MeetingState.MEETING_STARTED ]: "started",
		[ MeetingState.MEETING_ENDED ]: "ended",
		[ MeetingState.MEETING_COMPLETED ]: "finalized",
	};

	constructor( meetingId, meetingState ) {
		if ( !isMeetingStateValid( meetingState ) ) {
			throw new Error( `meeting state is invalid: ${ meetingState }` );
		}
		super();
		this.name = "Meeting Viewed";
		this.eventProperties.meeting_id = meetingId;
		this.eventProperties.meeting_state = this.stateMap[ meetingState ];
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/MeetingViewedEvent.js